var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-divider-wrapper"},[_c('v-divider',{staticClass:"card-divider",class:{ vertical: _vm.vertical },attrs:{"vertical":_vm.vertical}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }